export default __webpack_public_path__ + "static/media/linked.fd451e15.svg";